// @flow

import React from 'react';

type Props = {
  newValue: number,
  oldValue: number,
  digit: number,
}

class PercentageChange extends React.Component<Props> {

  getRoundWithDigit = (): {} => {
    // Pas de division par 0
    if (this.props.oldValue === 0) {
      return '-';
    }
    const percentage = ((this.props.newValue - this.props.oldValue) / this.props.oldValue) * 100;
    const percentageRounded = Number(percentage.toFixed(this.props.digit));
    return percentageRounded + '%';
  }

  render() {
    const toDisplay = this.getRoundWithDigit();
    return (
      <p>{toDisplay}</p>
    );
  }
}

export default PercentageChange;
